import { useQueryClient } from "react-query";
import { useMutation } from "react-query";
import { notification } from "antd";
import { isError } from "utils/api/models/api-response";
import { PostClientRequest } from "services/clientRequests";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";

export default function AddClientRequest() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return {
    ...useMutation(PostClientRequest, {
      onSuccess: async (res) => {
        if (!isError(res)) {
          notification.open({
            type: "success",
            message: t("the_request_has_been_created_successfully"),
          });
          queryClient.invalidateQueries("tickets");
          queryClient.invalidateQueries("clientRequests");
        }
      },
    }),
  };
}
